'use client'
import AlertBanner from '@hashicorp/react-alert-banner'
import type { ComponentProps } from 'react'

export default function Banner(props: ComponentProps<typeof AlertBanner>) {
	return <AlertBanner {...props} />
}
